// extracted by mini-css-extract-plugin
export var form_grp = "postCommentForm-module--form_grp--45d3d";
export var full_col = "postCommentForm-module--full_col--59282";
export var input_grp = "postCommentForm-module--input_grp--b28e0";
export var post_comment_form = "postCommentForm-module--post_comment_form--98005";
export var post_comment_form_left = "postCommentForm-module--post_comment_form_left--bc593";
export var post_comment_form_listing = "postCommentForm-module--post_comment_form_listing--4f48c";
export var post_comment_form_wrap = "postCommentForm-module--post_comment_form_wrap--235b1";
export var submit_area = "postCommentForm-module--submit_area--6744b";
export var submit_btn = "postCommentForm-module--submit_btn--abc21";
export var two_col = "postCommentForm-module--two_col--06c87";